import React, { useState } from 'react';
import styled from 'styled-components'
import CsvEnrichmentForm from '../components/csv-enrichment/CsvEnrichmentForm';
import CSVEnrichmentList from '../components/csv-enrichment/CSVEnrichmentList';
import Row from '../../../components/Row';
import { styles } from './../../../styles/themes/style';

const CsvEnrichmentSection = () => {
  const [selectedPage, setSelectedPage] = useState<string>('csvEnrichmentForm')

    const sections = [
      {id: 'csvEnrichmentForm', label: 'CSV Enrichment'},
      {id: 'enrichedCSVs', label: 'Enriched CSVs'},
  ]

  const renderRoute = () => {
    switch (selectedPage) {
      case 'csvEnrichmentForm':
        return <CsvEnrichmentForm />
      case 'enrichedCSVs':
        return <CSVEnrichmentList />
      default:
        return <CsvEnrichmentForm />
    }
  }

  return (
    <Container>
      <FixedHeader>
        <StyledRow gap='10px'>
            {sections.map((section) => (
                <NavButton key={section.id} $disabled={false} $selected={selectedPage === section.id}>
                    <a onClick={() => setSelectedPage(section.id)}>{section.label}</a>
                </NavButton>
            ))}
        </StyledRow>
      </FixedHeader>
      <ScrollableContent>
        {renderRoute()}
      </ScrollableContent>
    </Container>
  );
};

const Container = styled.div`
    width: 100%;
    height: 700px;
    max-height: 700px;
    padding: 0px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-bottom: 1px solid ${({ theme: { quinaryColor} }) => quinaryColor};
`

const FixedHeader = styled.div`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const ScrollableContent = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0; /* Important for flex child to be scrollable */
`

const StyledRow = styled(Row)`
  border-bottom: 1px solid ${({ theme: { quinaryColor} }) => quinaryColor};
`
const NavButton = styled.div<{$disabled?: boolean, $selected?: boolean}>`
    line-height: 20px;
    font-family: NunitoSans;
    font-size: 14px;
    font-weight: bold;
    padding: 0px 12px;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 12px;
    a {
      ${({ theme: { primaryColor } }) => primaryColor && `color: ${primaryColor};`}
    }
    ${({ $disabled }) => $disabled && `
        cursor: default;
        a, &:hover a, &:focus a{
            cursor: default;
            color: ${styles} !important;
        }
    `}
    ${({ $selected }) => $selected && `
        border-bottom: 2px solid #5964FF;
        cursor: default;
        a {
            cursor: default;
            color: ${styles.colors.primary600} !important;
        }
    `}
`
export default CsvEnrichmentSection;